module.exports = __webpack_public_path__ + "static/media/focused.655e0eab.svg";